import API from "../../../../../global/api";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { isEmpty, sumBy } from "lodash";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { textData } from "../../../../../global/test";
// import autoTable from "jspdf-autotable";


export const requestAddConstructionOrder = () => {
    return {
        type: "REQUEST_ADD_CONSTRUCTION_ORDER",
    };
};
export const successAddConstructionOrder = (data) => {
    return {
        type: "SUCCESS_ADD_CONSTRUCTION_ORDER",
        payload: data,
    };
};
export const errorAddConstructionOrder = () => {
    return {
        type: "ERROR_ADD_CONSTRUCTION_ORDER",
    };
};
export const AddConstructionOrderApi = (payload, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddConstructionOrder());
        API.post(`/construction/add-construction-order`, payload)
            .then((res) => {
                dispatch(successAddConstructionOrder(payload));
                showSuccessAlert(res.data.message);
            }).catch((error) => {
                dispatch(errorAddConstructionOrder());
                showErrorAlert(error.response.data.message || "Something went wrong");
            });
    };
};


export const resetConstructionOrderData = () => {
    return {
        type: "RESET_CONSTRUCTION_ORDER_DATA",
    };
};


export const requestGetConstructionOrder = () => {
    return {
        type: "REQUEST_GET_CONSTRUCTION_ORDER",
    };
};
export const successGetConstructionOrder = (response) => {
    return {
        type: "SUCCESS_GET_CONSTRUCTION_ORDER",
        payload: response,
    };
};
export const errorGetAllConstructionOrder = () => {
    return {
        type: "ERROR_GET_CONSTRUCTION_ORDER",
    };
};
export const GetConstructionOrderApi = () => {
    return (dispatch) => {
        dispatch(requestGetConstructionOrder());
        API.get(`/construction/get-construction-orders`)
            .then((res) => {
                let response = res.data;
                dispatch(successGetConstructionOrder(response));
            }).catch((error) => {
                dispatch(errorGetAllConstructionOrder());
            });
    };
};


export const DeleteRequestConstructionOrder = () => {
    return {
        type: "DELETE_REQUEST_CONSTRUCTION_ORDER",
    };
};
export const DeleteSuccessConstructionOrder = (orderId) => {
    return {
        type: "DELETE_SUCCESS_CONSTRUCTION_ORDER",
        orderId: orderId,
    };
};
export const DeleteErrorConstructionOrder = () => {
    return {
        type: "DELETE_ERROR_CONSTRUCTION_ORDER",
    };
};
export const DeleteConstructionOrderApi = (orderId) => {
    return (dispatch) => {
        dispatch(DeleteRequestConstructionOrder());
        API.delete(`/construction/delete-construction-order/${orderId}`)
            .then((res) => {
                dispatch(DeleteSuccessConstructionOrder(orderId));
            }).catch((error) => {
                dispatch(DeleteErrorConstructionOrder());
            });
    };
};


export const RequestGetConstructionWithId = () => {
    return {
        type: "REQUEST_GET_CONSTRUCTION_ORDER_WITH_ID",
    };
};
export const SuccessGetConstructionWithId = (data) => {
    return {
        type: "SUCCESS_GET_CONSTRUCTION_ORDER_WITH_ID",
        payload: data,
    };
};
export const ErrorGetConstructionWithId = () => {
    return {
        type: "ERROR_GET_CONSTRUCTION_ORDER_WITH_ID",
    };
};
export const GetConstructionOrderWithIdApi = (orderId) => {
    return (dispatch) => {
        dispatch(RequestGetConstructionWithId());
        API.get(`/construction/get-construction-withID/${orderId}`)
            .then((res) => {
                let data1 = res.data;
                dispatch(SuccessGetConstructionWithId(data1));
            }).catch((error) => {
                dispatch(ErrorGetConstructionWithId());
            });
    };
};


export const PDF_TRANSLATIONS = {
    en: {
        orderNumber: "Order Number",
        customerName: "Customer Name",
        date: "Date",
        deliveryDate: "Delivery Date",
        totalExpense: "Total Expense",
        vat: "VAT",
        finalTotal: "Final Total",
        total: "Total",
        productHeaders: ["#", "Product Name", "Quantity", "Price", "Total Sale Price"],
        serviceHeaders: ["#", "Description", "Quantity", "Price", "Total Price"],
    },
    ar: {
        orderNumber: "رقم الطلب",
        customerName: "اسم العميل",
        date: "التاريخ",
        deliveryDate: "تاريخ التسليم",
        totalExpense: "إجمالي المصروفات",
        vat: "ضريبة القيمة المضافة",
        finalTotal: "الإجمالي النهائي",
        total: "المجموع",
        productHeaders: ["م", "اسم المنتج", "الكمية", "السعر", "إجمالي قيمة البيع"],
        serviceHeaders: ["م", "الوصف", "الكمية", "السعر", "إجمالي السعر"],
    },
};
export const GenerateOrderPDF = (orderData) => {
    return (dispatch) => {
        const language = window.localStorage.getItem("lang") || "en";
        const isArabic = language === "ar";
        const t = PDF_TRANSLATIONS[language] || PDF_TRANSLATIONS["en"];

        const doc = new jsPDF("p", "pt", "A4");
        PDFHeader(doc, "Order Report");


        doc.addFileToVFS("Amiri-Regular.ttf", textData);
        doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
        const activeFont = isArabic ? "Amiri" : "helvetica";
        const activeFontStyle = "normal";
        doc.setFont(activeFont, activeFontStyle);
        doc.setFontSize(10);


        doc.text(`${t.orderNumber}: ${orderData.sequenceNumber}`, 50, 130);
        doc.text(`${t.customerName}: ${orderData.customerDetails?.name}`, 50, 145);
        doc.text(`${t.date}: ${orderData.date}`, 50, 160);
        doc.text(`${t.deliveryDate}: ${orderData.deliveryDate}`, 50, 175);

        const productHeaders = [t.productHeaders];
        const prodactData = isEmpty(orderData.productExpenseData) ? [] : orderData.productExpenseData.map((elt, i) => [
            i + 1,
            elt.productName,
            elt.quantity,
            elt.salePrice,
            elt.totalSalePrice,
        ]);
        if (!isEmpty(prodactData)) {
            prodactData.push(["", "Total", "", "", Math.round(sumBy(prodactData, "4") * 100) / 100,]);
        }
        doc.autoTable({
            startY: 190,
            head: productHeaders,
            body: prodactData,
            theme: "grid",
            styles: {
                font: activeFont,
                fontStyle: activeFontStyle,
                fontSize: 10,
                // halign: isArabic ? "right" : "left",
            },
            headStyles: {
                fillColor: "#2980ba",
                font: activeFont,
                fontStyle: activeFontStyle,
                fontSize: 10,
                // halign: isArabic ? "right" : "left",
            },
        });


        const serviceHeaders = [t.serviceHeaders];
        const ExtraServiceData = isEmpty(orderData.extraServiceExpenseData) ? [] : orderData.extraServiceExpenseData.map((elt, i) => [
            i + 1,
            elt.description,
            elt.quantity,
            elt.price,
            elt.totalPrice,
        ]);
        if (!isEmpty(ExtraServiceData)) {
            ExtraServiceData.push(["", "Total", "", "", Math.round(sumBy(ExtraServiceData, "4") * 100) / 100,]);
        }
        doc.autoTable({
            startY: doc.lastAutoTable.finalY + 15,
            head: serviceHeaders,
            body: ExtraServiceData,
            theme: "grid",
            // columnStyles: isArabic
            //     ? Object.fromEntries(
            //         t.serviceHeaders.map((_, i) => [
            //             i,
            //             { halign: "right" },
            //         ])
            //     )
            //     : {},
            styles: {
                font: activeFont,
                fontStyle: activeFontStyle,
                fontSize: 10,
                // halign: isArabic ? "right" : "left",
            },
            headStyles: {
                fillColor: "#2980ba",
                font: activeFont,
                fontStyle: activeFontStyle,
                fontSize: 10,
                // halign: isArabic ? "right" : "left",
            },
        });


        const finalY = doc.lastAutoTable.finalY;
        doc.text(`${t.totalExpense} = ${orderData.totalExpense || 0}`, 50, finalY + 40);
        doc.text(`${t.vat} = ${orderData.vatTotal || 0}`, 50, finalY + 60);
        doc.text(`${t.finalTotal} = ${orderData.finalTotal || 0}`, 50, finalY + 80);


        doc.setProperties({ title: `Order Print ${moment().format("YYYY-MM-DD")}` });
        window.open(URL.createObjectURL(doc.output("blob")));
    };
};


export const UpdateConstructionOrderApi = (orderId, data, onSuccess, onError) => (dispatch) => {
    dispatch({
        type: "UPDATE_CONSTRUCTION_ORDER_REQUEST",
    });

    API.put(`/construction/update-construction-order/${orderId}`, data).then((result) => {
        dispatch({
            type: "UPDATE_CONSTRUCTION_ORDER_SUCCESS",
            payload: result.data,
        });
        onSuccess?.();
    }).catch((error) => {
        dispatch({
            type: "UPDATE_CONSTRUCTION_ORDER_FAILURE",
            payload: error.message,
        });
        onError?.(error.message);
    });
};